<template>
  <q-page padding>
    <div class="fit row justify-between items-start">
      <div class="row col-12 text-brand-5" @click="voltar(ptId)">
        <q-icon
          style="margin-top: 4px"
          size="sm"
          name="arrow_back_ios"
          class="cursor"
        />
        <p class="text-h6 text-brand-5 text-weight-bold titulo-pagina">
          Assinatura do Responsável: #{{ responsavelId }}
        </p>
      </div>

      <div class="row col-12 q-gutter-sm q-mt-sm">
        <div
          class="text-brand-5 text-weight-bold col-md-2 col-sm-4 col-xs-5 titulo-input"
        >
          <div>Nome do Responsavel</div>
          <q-input
            dense
            outlined
            v-model="dados.nome"
            disable
            bg-color="brand-7"
            class="input"
          />
        </div>
        <div
          class="text-brand-5 text-weight-bold col-md-1 col-sm-3 col-xs-3 titulo-input"
        >
          <div>Matricula</div>
          <q-input
            dense
            outlined
            disable
            v-model="dados.matricula"
            bg-color="brand-7"
            class="input"
          />
        </div>
        <div
          class="text-brand-5 text-weight-bold col-md-1 col-sm-3 col-xs-3 titulo-input"
        >
          <div>Tipo</div>
          <q-input
            dense
            outlined
            disable
            v-model="dados.tipo"
            bg-color="brand-7"
            class="input"
          />
        </div>
        <div
          class="text-brand-5 text-weight-bold col-md-2 col-sm-6 col-xs-6 titulo-input"
        >
          <div>Empresa</div>
          <q-input
            dense
            outlined
            disable
            v-model="pt.empresa"
            bg-color="brand-7"
            class="input"
          />
        </div>
        <div
          class="text-brand-5 text-weight-bold col-md-2 col-sm-5 col-xs-5 titulo-input"
        >
          <div>Tipo de Assinatura</div>
          <div class="relative-position">
            <q-select
              dense
              outlined
              option-label="label"
              option-value="value"
              :options="tipoAssinaturaOptions"
              v-model="assinatura"
              class="input"
              :disable="tipoAssinaturaOptions.length === 0"
              :label="
                tipoAssinaturaOptions.length === 0
                  ? 'Nenhum método disponível'
                  : 'Selecione o tipo de assinatura'
              "
            />
            <q-tooltip
              v-if="tipoAssinaturaOptions.length === 0"
              class="bg-negative"
            >
              Nenhum método disponível
            </q-tooltip>
          </div>
        </div>
      </div>
      <div class="col-12 q-mt-lg canvas-container">
        <ColetarAssinaturaResponsavel
          v-if="tipoAssinaturaOptions.length > 0 && dados.ptId"
          :usuarioPodeEditar="pt.status === 'finalizado'"
          :assinante="dados"
          @closeDialog="voltar(ptId)"
          :tipoAssinatura="assinatura?.value"
        />

        <div
          v-else-if="dados.ptId && tipoAssinaturaOptions.length === 0"
          class="q-pa-xl text-center text-negative rounded-borders"
        >
          <div>
            <q-icon name="warning" size="lg" class="q-mb-md" />
            <div class="text-h6 q-mb-sm">Sem métodos de autenticação</div>
            <div>
              Não existe nenhum método de autenticação para seu perfil, contate
              o suporte
            </div>
          </div>
        </div>
      </div>
    </div>
  </q-page>
</template>

<script>
import { computed, ref, onMounted } from "@vue/runtime-core";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
// import { useQuasar } from "quasar";
import ColetarAssinaturaResponsavel from "../components/ColetarAssinaturaResponsavel.vue";

export default {
  components: { ColetarAssinaturaResponsavel },
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const ptId = route.params.ptId;
    const responsavelId = route.params.responsavelId;
    const pt = ref(false);
    const disableObs = ref(false);
    const tipoAssinaturaOptions = ref([
      {
        label: "Assinatura na Tela",
        value: "manual",
        permission: "pdt-auth-assinatura",
      },
      {
        label: "Assinatura Eletrônica",
        value: "eletronica",
        permission: "pdt-auth-token",
      },
      {
        label: "Biometria",
        value: "biometria",
        permission: "pdt-auth-biometria",
      },
      {
        label: "Pin",
        value: "pin",
        permission: "pdt-auth-pin",
      },
      {
        label: "Facial",
        value: "facial",
        permission: "pdt-auth-facial",
      },
    ]);
    const dados = ref({});
    const assinatura = ref(null);

    const buscarDetalhePt = async () => {
      tipoAssinaturaOptions.value = tipoAssinaturaOptions.value.filter(
        (value) =>
          !value.permission ||
          store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.includes(
            value.permission
          )
      );

      store.dispatch("pdt/hiddenHeader", true);
      const resposta = await store.dispatch("pdt/buscarDetalhePt", { ptId });
      pt.value = resposta.data.resultado.dados;

      pt.value.responsaveis.forEach((value) => {
        if (value.responsavelId == responsavelId) {
          dados.value = { ...value, ptId };
        }
      });
      
      if (pt.value?.unidadeId && (dados.value.matricula || dados.value.nome)) {
        await buscarDadosUsuario();
      }
    };
    
    const buscarDadosUsuario = async () => {
      if (!pt.value?.unidadeId || (!dados.value.matricula && !dados.value.nome)) {
        console.warn("Dados insuficientes para buscar usuário");
        dados.value.biometria_facial = 0;
        dados.value.usuarioIdReal = null;
        return;
      }

      try {
        const responseList = await store.dispatch("user/getUsuarios", {
          vendor_id: pt.value.unidadeId,
          per_page: 10,
          page: 1,
          search: dados.value.matricula || dados.value.nome,
        });
        
        const usuarios = responseList.data?.results?.data || responseList.data?.data || [];

        // busca o usuario pela matrícula
        const usuarioEncontrado = usuarios.find(u => 
          u.sap === dados.value.matricula || 
          u.tnumber === dados.value.matricula
        );
        
        if (usuarioEncontrado) {
          dados.value.biometria_facial = usuarioEncontrado.biometria_facial || 0;
          dados.value.usuarioIdReal = usuarioEncontrado.id;
        } else {
          console.warn("Usuário não encontrado pela matrícula:", dados.value.matricula);
          dados.value.biometria_facial = 0;
          dados.value.usuarioIdReal = null;
        }
      } catch (error) {
        console.warn("Erro ao buscar dados do usuário:", error.message);
        dados.value.biometria_facial = 0;
        dados.value.usuarioIdReal = null;
      }
    };

    const usuarioPodeEditar = computed(() => {
      if (!pt.value) {
        return false;
      }

      return (
        store.getters["autenticacao/usuarioLogado"].id ===
        pt.value.emissorMatricula
      );
    });

    const voltar = async (ptId) => {
      router.push({ name: "pdt-pt-detalhe", params: { ptId } });
    };

    onMounted(buscarDetalhePt);

    return {
      ptId,
      pt,
      buscarDetalhePt,
      usuarioPodeEditar,
      disableObs,
      voltar,
      responsavelId,
      dados,
      tipoAssinaturaOptions,
      assinatura,
    };
  },
};
</script>

<style scoped>
.elipse {
  width: 12px;
  height: 12px;
  border-radius: 50%;
}
.cursor {
  cursor: pointer;
}
@media (max-width: 600px) {
  .titulo-pagina {
    font-size: 14px;
  }
  .cursor {
    font-size: 14px !important;
    margin-top: 9px !important;
  }
  .titulo-input {
    font-size: 12px;
  }
  .input {
    font-size: 12px;
  }
}
</style>
